import angular from 'angular';
// import moment from 'moment';
import ChangeIdFormInfo from '../seller/change-id-form-info.data';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('InvitedEntityBo', InvitedEntityBoData);

    InvitedEntityBoData.$inject = [
        '$translate',
        'InvitedEntity',
        'User',
        'SellerPrincipal',
        'PrincipalDetail',
        'Invitation',
    ];

    /* @ngInject */
    function InvitedEntityBoData($translate, InvitedEntity, User, SellerPrincipal, PrincipalDetail, Invitation) {
        InvitedEntityBo.prototype = {
            build: build,
            buildEmpty: buildEmpty,
        };

        function InvitedEntityBo(invitedEntityBoData) {
            if (!invitedEntityBoData) {
                this.buildEmpty();
            } else {
                this.build(invitedEntityBoData);
            }
        }

        return InvitedEntityBo;

        /////////////////////

        function buildEmpty() {
            this.invitedEntity = new InvitedEntity();
            this.changeIdFormInfo = new ChangeIdFormInfo();
            this.users = [];
            this.principalEntity = new PrincipalDetail();
            this.invitations = [];
        }

        function build(invitedEntityBoData) {
            this.invitedEntity = new InvitedEntity(invitedEntityBoData.invitedEntity);
            this.changeIdFormInfo = invitedEntityBoData.changeIdFormInfo
                ? new ChangeIdFormInfo(invitedEntityBoData.changeIdFormInfo, $translate)
                : null;
            this.users = {
                totalItems: invitedEntityBoData.users.length,
                items: _.map(invitedEntityBoData.users, function (u) {
                    return new User(u);
                }),
            };
            this.principal = {
                totalItems: invitedEntityBoData.principalRelations.length,
                items: _.map(invitedEntityBoData.principalRelations, function (p) {
                    return new SellerPrincipal(p);
                }),
            };
            this.principalEntity = new PrincipalDetail(invitedEntityBoData.principal);
            this.invitations = {
                totalItems: invitedEntityBoData.invitations.length,
                items: _.map(invitedEntityBoData.invitations, function (i) {
                    return new Invitation(i);
                }),
            };
        }
    }
})();
